// src/pages/AppliAdmin/ContactForm/ContactForm.jsx
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "./../../hooks/useScrollToTop";
import ScrollIndicator from "./../../hooks/ScrollIndicator";

import { useContactFormMessages } from "./useContactFormMessages";

import ContactAdminHeader from "./components/ContactAdminHeader";
import ContactFiltersBar from "./components/ContactFiltersBar";
import ContactMessagesPanel from "./components/ContactMessagesPanel";
import ContactPagination from "./components/ContactPagination";

const PAGE =
  "min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-50";

export default function ContactForm() {
  useScrollToTop();

  const {
    pageRows,
    filteredMessages,
    stats,

    unreadCount,
    loading,
    deletingId,
    markingId,

    q,
    setQ,
    readFilter,
    setReadFilter,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    sort,
    setSort,

    page,
    setPage,
    pageSize,
    setPageSize,
    pageCount,

    loadMessages,
    toggleReadStatus,
    markAllAsRead,
    deleteMessage,
    exportCSV,
    resetFilters,
  } = useContactFormMessages();

  return (
    <div className={PAGE}>
      <ScrollIndicator />

      <main className="mx-auto w-full max-w-[1280px] px-3 pb-12 pt-[120px] sm:px-5 md:pt-[145px]">
        <div className="space-y-6">
          <ContactAdminHeader
            stats={stats}
            unreadCount={unreadCount}
            loading={loading}
            onRefresh={loadMessages}
          />

          <ContactFiltersBar
            q={q}
            setQ={(value) => {
              setQ(value);
              setPage(1);
            }}
            readFilter={readFilter}
            setReadFilter={(value) => {
              setReadFilter(value);
              setPage(1);
            }}
            dateFrom={dateFrom}
            setDateFrom={(value) => {
              setDateFrom(value);
              setPage(1);
            }}
            dateTo={dateTo}
            setDateTo={(value) => {
              setDateTo(value);
              setPage(1);
            }}
            sort={sort}
            setSort={(value) => {
              setSort(value);
              setPage(1);
            }}
            onExport={exportCSV}
            onMarkAllRead={markAllAsRead}
            onResetFilters={resetFilters}
          />

          <ContactMessagesPanel
            rows={pageRows}
            loading={loading}
            deletingId={deletingId}
            markingId={markingId}
            onDelete={deleteMessage}
            onToggleRead={toggleReadStatus}
            searchTerm={q}
          />

          <ContactPagination
            page={page}
            setPage={setPage}
            pageCount={pageCount}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={filteredMessages.length}
          />

          <div className="rounded-[24px] border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
            Total : <strong>{stats.total}</strong> • Affichés :{" "}
            <strong>{stats.filtered}</strong> • Non lus :{" "}
            <strong>{stats.unread}</strong> • Lus :{" "}
            <strong>{stats.read}</strong>
          </div>
        </div>
      </main>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
